export enum MenuPanels {
  LAYOUT = 'layout',
  FILL = 'fill',
  OUTLINE = 'outline',
  NONE = 'none',
  BACKGROUND = 'background',
  BORDER = 'border',
  ICON_COLOR = 'icon-color',
  FONT_ONE = 'font_one',
  FONT_TWO = 'font_two',
  INTRO_ANIMATION = 'intro-animation',
  OUTRO_ANIMATION = 'outro-animation',
}
